import { AddIcon } from '@chakra-ui/icons';
import { Tooltip } from '@chakra-ui/react';

import { Button } from 'components/v4';

function PlusIconButton({ currentRow, currentIndex, onOpen, setSelectedRow }) {
    return (
        <Tooltip
            hasArrow
            label={`Add ${currentRow.first}`}
            placement="left"
            shouldWrapChildren>
            <Button
                size="sm"
                aria-label={`Add-Number-Blocks-${currentIndex}`}
                onClick={() => {
                    onOpen();
                    setSelectedRow(currentRow);
                }}
                leftIcon={<AddIcon boxSize={3} />}>
                Add
            </Button>
        </Tooltip>
    );
}

export default PlusIconButton;
